module.exports = __webpack_public_path__ + "img/phone-img.94814dbd.png";